import * as yup from 'yup'

export const validationSchema = yup.object({
  motivo: yup
    .string()
    .required('O campo é obrigatório.')
    .min(3, 'O campo não atingiu o limite mínimo de 3 caracteres.')
    .max(255, 'O campo atingiu o limite mínimo de 255 caracteres.')
})
